import { PlayerUser } from './player-user.model';
import { Uuid } from '@hidat/huijs-common';
import { Expose, Type } from 'class-transformer';
import { PlayerInstanceInterface } from '@splixer/common';
import * as dayjs from 'dayjs';

export class PlayerInstance implements PlayerInstanceInterface {
  @Expose({ name: 'uid' })
  uid: Uuid | undefined = undefined;

  // Guid
  @Expose({ name: 'listener_id' })
  listenerId: Uuid | undefined = undefined;
  @Expose()
  @Type(() => PlayerUser)
  _user: PlayerUser | undefined = undefined;

  // Keep compiler happy
  id: number | undefined;
  createdAt: dayjs.Dayjs | undefined;
  updatedAt: dayjs.Dayjs | undefined;
}
